// extracted by mini-css-extract-plugin
export default {"listaUsuarios":"Usuarios_listaUsuarios__qNazB","etiquetaTu":"Usuarios_etiquetaTu__Qzjl2","interruptor":"Usuarios_interruptor__OJui0","correoMovil":"Usuarios_correoMovil__Ivnky"};